export default __webpack_public_path__ + "b973d55a5973c9cfb6dcce5ccac1b296.svg";